export const GET_RATING_CODES_FAILURE = 'GET_RATING_CODES_FAILURE';

export const getRatingCodesFailure = error => ({
    type: GET_RATING_CODES_FAILURE,
    payload: error,
    error: true,
});
